import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import {getRating, convertRatingDecimalToDash, getSizeInPixels} from './utils/starRating';
import './StarRating.less';

const StarRating = ({rating, size, className, children}) => {
    const sizeVariant = getSizeInPixels(size);
    const inputVariant = (children) ? 'StarRatingInput' : 'StarRatingStatic';
    const inputSizeVariantClass = `${inputVariant}--${sizeVariant}`;

    const roundedRating = getRating(rating);
    const ratingClassSuffix = convertRatingDecimalToDash(roundedRating);
    const starClasses = classNames(`StarRating__stars StarRating__stars--${ratingClassSuffix}`, inputSizeVariantClass, `${inputVariant}`, className);

    return (
        <div className={starClasses}>
            {children}
        </div>
    );
};

StarRating.propTypes = {
    /** Raw Rating Number.  StarRating will round to the correct half star. */
    rating: PropTypes.number.isRequired,
    /** The StarRating size variation, one of: '12'|'16'|'24'|'32'. The value corresponds to the px height of the stars. 'sm' and 'lg' are deprecated and map to 12 and 24 respectively.  */
    size: PropTypes.oneOf(['12', '16', '24', '32', 'lg', 'sm'])
};

StarRating.defaultProps = {
    rating: 0,
    size: '16'
};

export default StarRating;
